<div class="phx-skeleton-wrapper" [style.flexDirection]="phxDirection === 'column'? 'row': 'column'" [style.gap]="phxSpacing" [class.phx-skeleton-animated]="phxShouldShowAnimation">
  <div *ngFor="let skeleton of skeletons" class="phx-skeleton-item"></div>
</div>